import { Link } from 'react-router-dom';
import { ArrowRight, Check, Clock } from '@phosphor-icons/react';

export default function RecentActivity({ completions }) {
  if (!completions.length) return null;
  return (
    <div className="tactical-card p-6 mt-4" data-testid="recent-activity">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold tracking-tight">RECENT ACTIVITY</h3>
        <Link to="/workouts/history" className="text-sm text-[#FF3B30] hover:text-[#FF645A] font-bold flex items-center gap-1">
          View All <ArrowRight weight="bold" className="w-3 h-3" />
        </Link>
      </div>
      <div className="space-y-2">
        {completions.map((c) => (
          <div key={c.id || c.completed_at} className="flex items-center justify-between bg-[#1C1C1E] border border-white/5 px-4 py-3">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-[#34C759]/10 flex items-center justify-center">
                <Check weight="bold" className="w-4 h-4 text-[#34C759]" />
              </div>
              <div>
                <div className="text-sm font-medium">{c.exercises_completed} exercise{c.exercises_completed !== 1 ? 's' : ''} completed</div>
                <div className="text-xs text-[#71717A]">{c.date}</div>
              </div>
            </div>
            <div className="flex items-center gap-2 text-sm text-[#A1A1AA]">
              <Clock className="w-4 h-4" />
              {c.duration_minutes} min
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
